import { BrowserRouter, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import Landing from './Landing';
import Consulting from './Consulting';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import CookiesPolicy from './CookiesPolicy';
import ContactPage from './ContactPage';
import { LangProvider } from './LangContext';
// import WhatsAppFloatButton from './components/WhatsAppFloatButton';
import ShareButton from './components/ShareButton';
import ChatBot from './components/ChatBot';
import './index.css';

function AppLayout() {
  return (
    <LangProvider>
      <Outlet />
    </LangProvider>
  );
}

function CatchAll() {
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          {/* ES routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/consultoria" element={<Consulting />} />
          <Route path="/privacidad" element={<PrivacyPolicy />} />
          <Route path="/terminos" element={<TermsOfService />} />
          <Route path="/politica-de-cookies" element={<CookiesPolicy />} />
          <Route path="/contacto" element={<ContactPage />} />
        </Route>
        <Route path="/en" element={<AppLayout />}>
          <Route index element={<Landing />} />
          <Route path="consultoria" element={<Consulting />} />
          <Route path="privacidad" element={<PrivacyPolicy />} />
          <Route path="terminos" element={<TermsOfService />} />
          <Route path="politica-de-cookies" element={<CookiesPolicy />} />
          <Route path="contacto" element={<ContactPage />} />
        </Route>
        <Route path="*" element={<CatchAll />} />
      </Routes>
      {/* <WhatsAppFloatButton /> */}
      <ShareButton />
      <ChatBot />
    </BrowserRouter>
  );
}

export default App;
